{
  "name": "timeghost",
  "version": "1.1.0",
  "private": true,
  "scripts": {
    "ng": "ng",
    "git": "node ./git-config.cjs",
    "prod": "cross-env NODE_ENV=production npm run build -- --configuration production && pnpm sentry:sourcemaps",
    "prod:hm": "cross-env NODE_ENV=production npm run build:hm -- --configuration production && pnpm sentry:sourcemaps",
    "build": "npm run env -s && ng build",
    "build:hm": "npm run env -s && node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build",
    "analyze:es5": "webpack-bundle-analyzer dist/stats-es2015.json",
    "start": "npm run env -s && node --max_old_space_size=16384 ./node_modules/@angular/cli/bin/ng serve --hmr",
    "dev": "cross-env TAILWIND_MODE=watch npm run start -- --ssl --ssl-key localhost.key --ssl-cert localhost.crt",
    "dev:local": "cross-env AZ_FUNC_ENDPOINT=http://localhost:7071/api npm run dev --",
    "light:start": "cross-env NODE_OPTIONS=--max-old-space-size=400 npm start",
    "serve:sw": "npm run build -s && npx http-server ./dist -p 4200",
    "lint": "biome check ./src",
    "test": "npm run env -s && ng test",
    "test:unit": "vitest run",
    "test:unit:watch": "vitest",
    "test:ci": "npm run env -s && npm run lint -s && ng test --code-coverage --watch=false",
    "e2e": "npm run env -s && ng e2e",
    "translations:extract": "ngx-translate-extract --input ./src --output ./src/translations/template.json --format=json --clean -sort --marker extract",
    "env": "ngx-scripts env npm_package_version AZ_FUNC_ENDPOINT NODE_ENV && npm run git && cross-env NODE_OPTIONS=--max_old_space_size=8192",
    "prettier": "prettier",
    "prettier:check": "prettier --list-different \"./{src,e2e}/**/*.{ts,js,scss}\"",
    "biome:lint": "biome lint ./src",
    "biome:format": "biome format ./src --write",
    "prettier:format": "prettier --write \"./{src,e2e}/**/*.{html}\"",
    "biome:check": "biome check ./src",
    "biome:check:apply": "biome check ./src --apply",
    "postinstall": "npm run git",
    "generate": "ng generate",
    "refreshVSToken": "vsts-npm-auth -config .npmrc",
    "docker:build-agent": "docker run --env-file=./.env-docker --env-file=./.vscode/.docker -it mcr.microsoft.com/azure-pipelines/vsts-agent",
    "build:prod": "cross-env NODE_ENV=production ng build --configuration production",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org timeghost --project timeghost-time-tracking-frontend ./dist && sentry-cli --url https://error.timeghost.io/ sourcemaps upload --org timeghost --project timeghost-time-tracking-frontend ./dist"
  },
  "dependencies": {
    "@angular/animations": "^17.3.10",
    "@angular/cdk": "^17.3.10",
    "@angular/cdk-experimental": "^17.3.10",
    "@angular/common": "^17.3.10",
    "@angular/compiler": "^17.3.10",
    "@angular/core": "17.3.10",
    "@angular/forms": "^17.3.10",
    "@angular/http": "^7.2.15",
    "@angular/material": "^16.2.0",
    "@angular/platform-browser": "^17.3.10",
    "@angular/platform-browser-dynamic": "^17.3.10",
    "@angular/router": "^17.3.10",
    "@angular/service-worker": "^17.3.10",
    "@angularclass/hmr": "^3.0.0",
    "@azure/msal-angular": "^3.0.24",
    "@azure/msal-browser": "^3.24.0",
    "@datorama/akita": "^8.0.1",
    "@kurkle/color": "^0.1.9",
    "@lukeed/ms": "^2.0.2",
    "@microsoft/signalr": "^3.1.3",
    "@microsoft/teams-js": "2.35.0",
    "@ncstate/sat-popover": "^13.1.0",
    "@ngneat/bind-query-params": "^6.0.0",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@paralleldrive/cuid2": "^2.2.2",
    "@rx-angular/cdk": "^17.1.0",
    "@rx-angular/template": "^17.3.1",
    "@saschwarz/ngx-paddle-wrapper": "^1.1.1",
    "@sentry/angular": "^10.23.0",
    "@sentry/cli": "^2.58.0",
    "@tailwindcss/forms": "^0.3.3",
    "@tailwindcss/typography": "^0.5.2",
    "@tanstack/angular-query-experimental": "5.56.2",
    "@timeghost/web-api": "^0.0.41287",
    "angular-calendar": "^0.29.0",
    "angular-draggable-droppable": "^6.1.0",
    "angular-notifier": "^11.0.0",
    "angular-svg-icon": "^16.1.0",
    "apexcharts": "^3.54.1",
    "calendar-utils": "^0.8.2",
    "clsx": "^2.1.1",
    "colorthief": "^2.3.2",
    "crypto-browserify": "^3.12.0",
    "crypto-js": "^4.2.0",
    "date-fns": "^2.28.0",
    "date-fns-tz": "^1.1.4",
    "file-saver": "^2.0.5",
    "flexsearch": "^0.7.21",
    "fluent-sorter": "^1.1.2",
    "fuse.js": "^6.5.3",
    "immer": "6.0.6",
    "install": "^0.13.0",
    "jsonpath": "^1.1.1",
    "lodash": "^4.17.21",
    "lodash-es": "^4.17.21",
    "luxon": "^3.4.4",
    "marked": "^9.1.6",
    "material-design-icons-iconfont": "^6.1.0",
    "mime": "^2.4.4",
    "ng-apexcharts": "^1.12.0",
    "ngx-color-picker": "^16.0.0",
    "ngx-currency": "17.0.0",
    "ngx-date-fns": "^10.0.1",
    "ngx-device-detector": "^1.3.5",
    "ngx-flexible-layout": "https://github.com/Venipa/ngx-flex-layout#build/dev",
    "ngx-markdown": "^17.2.1",
    "ngx-mask": "^17.0.8",
    "ngx-mat-select-search": "^7.0.6",
    "ngx-material-timepicker": "^13.1.1",
    "ngx-scrollbar": "^4.1.1",
    "ngx-skeleton-loader": "^8.1.0",
    "ngx-sonner": "^1.0.0",
    "ngx-sub-form": "^8.0.0",
    "ngx-tippy-wrapper": "^5.0.1",
    "prismjs": "^1.29.0",
    "roboto-fontface": "^0.10.0",
    "rxjs": "^7.8.1",
    "rxjs-take-while-inclusive": "^2.1.0",
    "safe-stable-stringify": "^2.5.0",
    "secure-json-parse": "^2.7.0",
    "tailwind-merge": "^3.3.1",
    "thenby": "^1.3.4",
    "timezone-support": "^2.0.2",
    "tippy.js": "^6.3.7",
    "uuidv7": "^1.0.2",
    "zod": "^4.3.5",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "^17.0.2",
    "@angular-devkit/build-angular": "^17.3.8",
    "@angular/cli": "^17.3.8",
    "@angular/compiler-cli": "^17.3.10",
    "@angular/language-service": "17.3.10",
    "@biesbjerg/ngx-translate-extract": "^2.3.4",
    "@biomejs/biome": "^2.4.4",
    "@datorama/akita-ngdevtools": "^4.0.0",
    "@faker-js/faker": "^9.0.3",
    "@fullhuman/postcss-purgecss": "^4.0.3",
    "@microsoft/microsoft-graph-types": "1.8.0",
    "@ngx-rocket/scripts": "^3.0.1",
    "@phenomnomnominal/angular-lazy-routes-fix": "^0.1.5",
    "@tailwindcss/aspect-ratio": "^0.4.0",
    "@tailwindcss/line-clamp": "^0.4.0",
    "@types/crypto-js": "^4.2.2",
    "@types/events": "^3.0.0",
    "@types/file-saver": "^2.0.5",
    "@types/flexsearch": "^0.7.2",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "^2.0.6",
    "@types/jsonpath": "^0.2.4",
    "@types/lodash": "^4.14.182",
    "@types/lodash-es": "^4.17.6",
    "@types/luxon": "^1.12.0",
    "@types/mime": "^2.0.1",
    "@types/node": "20",
    "autoprefixer": "^10.2.6",
    "codelyzer": "^6.0.0",
    "core-js": "^2.6.4",
    "cross-env": "^5.2.0",
    "fast-glob": "^3.2.6",
    "fiber": "^1.0.4",
    "git-describe": "^4.0.4",
    "htmlhint": "^0.11.0",
    "https-proxy-agent": "^2.2.1",
    "lefthook": "^1.11.12",
    "ngx-infinite-scroll": "^17.0.1",
    "ngx-tailwind": "^4.0.0",
    "postcss": "^8.3.5",
    "postcss-import": "^14.0.2",
    "postcss-loader": "^6.2.0",
    "postcss-scss": "^4.0.1",
    "pretty-quick": "^4.0.0",
    "protractor": "^7.0.0",
    "purgecss-webpack-plugin": "^4.0.3",
    "sass": "^1.43.5",
    "sass-loader": "^12.3.0",
    "stylelint": "~10.0.1",
    "stylelint-config-recommended-scss": "~3.3.0",
    "stylelint-config-standard": "~18.3.0",
    "stylelint-scss": "^3.6.1",
    "tailwindcss": "^3.4.1",
    "ts-node": "~8.1.0",
    "tslib": "^2.8.1",
    "typescript": "^5.3.3",
    "ultracite": "6.5.1",
    "vitest": "^2.1.9",
    "webpack-bundle-analyzer": "^3.6.0"
  },
  "scarfSettings": {
    "enabled": false
  },
  "engines": {
    "node": ">=20.14.0",
    "pnpm": ">=10.17.0"
  },
  "volta": {
    "node": "22.10.0",
    "pnpm": "10.17.0"
  },
  "packageManager": "pnpm@10.17.0"
}
